import { Text } from '@mantine/core';
import { FC, Fragment } from 'react';

interface Props {
  text: string;
}

const TextWithLineBreaks: FC<Props> = ({ text }) => {
  const textWithBreaks = text.split('\n').map((t, index) => (
    <Fragment key={index}>
      <Text style={{fontSize: "20px"}} c="#0B2240" m={0} p={0}>{t}</Text>
    </Fragment>
  ));

  return <div>{textWithBreaks}</div>;
}

export default TextWithLineBreaks;